
  export default {
    name: `PrepareYourDocument`,
    props: {
      documentType: {
        type: String,
        required: false
      }
    },
    computed: {
      isMobile() {
        return this.$vuetify.breakpoint.smAndDown
      }
    },
    methods: {
      trans(key) {
        return this.$t(key, {docType: this.$t(`components.id_validator.document_type.full.` + this.documentType)})
      }
    }
  }
